// extracted by mini-css-extract-plugin
export var button = "table-column-sort-module--button--2lSe-";
export var icon = "table-column-sort-module--icon--3_VOi";